export const DIMENSION = {
  Desktop: 'desktop',
  Tablet: 'tablet',
  Mobile: 'mobile',
};

export const LAYOUT = {
  Fluid: 'fluid',
  Boxed: 'boxed',
};

export const RADIUS = {
  Rounded: 'rounded',
  Standard: 'standard',
  Flat: 'flat',
};

export const THEME_COLOR = {
  LightBlue: 'light-blue',
  DarkBlue: 'dark-blue',
  LightRed: 'light-red',
  DarkRed: 'dark-red',
  LightGreen: 'light-green',
  DarkGreen: 'dark-green',
  LightPurple: 'light-purple',
  DarkPurple: 'dark-purple',
  LightPink: 'light-pink',
  DarkPink: 'dark-pink',
};

export const NAV_COLOR = {
  Default: 'default',
  Light: 'light',
  Dark: 'dark',
};
export const MENU_PLACEMENT = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
};
export const MENU_BEHAVIOUR = {
  Pinned: 'pinned',
  Unpinned: 'unpinned',
};

export const USER_ROLE = {
  Admin: 'admin',
  Editor: 'editor',
};
export const ADMIN_PATH = {
  ACADEMIC_CONFIGURATION_OLD: "/acadmic-configurations",
  ACCESS_MANAGEMENT: "/access-management",
  HOME: "/administration",
  CORE_CONFIGURATION: "/core",
  CORE_GRADUATION_LEVELS: "/graduation-levels",
  CORE_BRANCHES: "/branches",
  CORE_COURSES: "/courses",
  CORE_INSTITUTES:"/institutes",
  CORE_UNIVERSITIES: "/universities",
  CORE_UNIVERSITY_CATEGORIES: "/university-categories",
  CORE_TERM_TYPES: "/term-types",
  CORE_SUBJECTS: "/subjects",
  CORE_SUBJECT_TYPES: "/subject-types",
  ACADEMIC_CONFIGURATION: "/academics",
  ACADEMIC_BATCH:"/batch",
  ACADEMIC_CLASSROOMS:"/classrooms",
  ACADEMIC_TERMS:"/terms",
  ACADEMIC_TERMSUBJECTS:"/term-subjects",
  CLASSROOM_CONFIGURATION: "/classroom",
  COMMUNITY_CONFIGURATION: "/community",
  COMMUNITY_OPENINGS:"/openings",
  COMMUNITY_APPLICANTS:"/applicants",
  EVENT_CONFIGURATION:"/events",
  EVENT_LIST:"/list",
  EVENT_LEADS:"/leads",
  EVENT_LIVE:"/live",
  EVENT_DRAFTS:"/drafts",
  EVENT_CONCLUDED:"/concluded",
  EVENT_ADD:"/add",
  EVENT_EDIT:"/edit",
  EVENT_MANAGE:"/manage",
  UNIVERSITIES: "/manage-universities",
  INSTITUTES: "/institutes",
  MANAGE_UNIVERSITY: "/universities",
  MANAGE_INSTITUTE: "/institutes",
  MANAGE_BATCH: "/batch",
  MANAGE_OPENING: "/opening",
  MANAGE_APPLICANT: "/applicant",
  TERMS:"/terms",
  TERM_SUBJECT:"/terms-subject",
  TRAINING_CONFIGURATION:"/trainings",
  TRAINING_ADD:"/add",
  TRAINING_LIST:"/list",
  TRAINING_EDIT:"/edit",
  TRAINING_MANAGE:"/manage",
  TRAINING_BATCH_CONFIGURATION:"/batches",
  TRAINING_BATCH_ADD:"/add",
  TRAINING_BATCH_EDIT:"/edit",
  TRAINING_BATCH_CONCLUDED:"/concluded",
  TRAINING_BATCH_DRAFTS:"/drafts",
  TRAINING_BATCH_LIVE:"/live",
  TRAINING_BATCH_MANAGE:"/manage"
}

export const USER_SETTINGS_PATH = {
  HOME: "/settings",
  PROFILE: "/profile",
  ACADEMICS: "/academics",
  TRAININGS: "/trainings",
  WORKEX: "/workex",
  PROJECTS: "/projects",
  ACCOUNT: "/account",
  CERTIFICATIONS: "/certifications"
}

export const USER_PORTFOLIO_PATH = {
  HOME: "/portfolio"
}

export const LEARNING_OPPORTUNITIES_PATH = {
  HOME: "/learning-opportunities"
}

export const CONSTANTS = {
  COORDINATOR_ROLES: ['aecl1', 'aecl2', 'aecl3', 'aecl4', 'std'],
  REGEX_PK: /^[a-zA-Z0-9]{1,50}$/,
  REGEX_USER_NAME: /^[a-zA-Z]{1,30}$/,
  REGEX_USER_GIVENNAME: /^[a-zA-Z\s]{3,50}$/,
  REGEX_USER_GIVENNAME_PARTS: /^[a-zA-Z]{3,20}$/,
  REGEX_MOBILE: /^[6-9]{1}[0-9]{9}$/,
  REGEX_CITY: /^[a-zA-Z][a-zA-Z\-\.\s]{1,49}$/,
  REGEX_DECIMAL_TILL_999: /^\d{1,3}((\.)(\d){1}){0,1}$/,
  REGEX_GRADE: /^[A-F]{1}$/,
  REGEX_ZIP: /^[1-9][0-9]{5}$/,
  REGEX_WEBURL: /^((http|https):\/\/)?(www.)?(?!.*(http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/,
  REGEX_BASE64_PDF: /^data:application\/pdf(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}$/,
  REGEX_BASE64_IMAGE_PNGJPG: /^data:image\/(?:png|jpeg|jpg)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}$/,
  REGEX_BASE64_IMAGE: /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}$/,
  REQUIRED_VALIDATION_ERR_MESSAGE: 'Required',  
}

export const PAYTM_MERCHANT_CONFIG = {
  root: "",
  flow: "DEFAULT",
  merchant: {
    mid:"",
    name: "Workabl - Infrings Technologies Pvt Ltd",
    logo: "https://console.workabl.in/img/favicon/favicon-196x196.png",
    redirect: false
  },
  payMode: {order: ["UPI","BALANCE","CARD","NB","LOGIN"]}
}